export default {
  data: () => ({
    translations: {
      addRegistrationPlan: {
        el: 'Προσθήκη πλάνου συνδρομής',
        en: 'Add Subscription Plan',
        it: 'Aggiungi piano di abbonamento',
      },
      addCompanySubscriptionPlan: {
        el: 'Προσθήκη Πλάνου Συνδρομής Εταιρίας',
        en: 'Add Company Subscription Plan',
        it: 'Add Company Subscription Plan',
      },
      name: {
        el: 'Name',
        en: 'Name',
        it: 'Nome',
      },
      plan_type: {
        el: 'Τύπος Πλάνου',
        en: 'Plan Type',
        it: 'Tipo di piano',
      },
      description: {
        el: 'Περιγραφή',
        en: 'Description',
        it: 'Descrizione',
      },
      price: {
        el: 'Τιμή',
        en: 'Price',
        it: 'Prezzo',
      },
      ratio: {
        el: 'Αναλογία',
        en: 'Ratio',
        it: 'Rapporto',
      },
      minimum_price: {
        el: 'Ελάχιστη τιμή',
        en: 'Minimum Price',
        it: 'Prezzo minimo',
      },
      price_type: {
        el: 'Τύπος Τιμής',
        en: 'Price Type',
        it: 'Tipo di prezzo',
      },
      plan_duration: {
        el: 'Διάρκεια',
        en: 'Duration',
        it: 'Durata',
      },
      payment_cycle: {
        el: 'Κύκλος πληρωμών',
        en: 'Payment Cycle',
        it: 'Ciclo di pagamento',
      },
      extra_properties: {
        el: 'Επιπλέον ιδιότητες',
        en: 'Extra Properties',
        it: 'Proprietà aggiuntive',
      },
      reward_points: {
        el: 'Πόντοι επιβράβευσης',
        en: 'Reward Points',
        it: 'Punti di ricompensa',
      },
      reward_cashback: {
        el: 'Cashback',
        en: 'Reward Cashback',
        it: 'Cashback di ricompensa',
      },
      public: {
        el: 'Δημόσιο',
        en: 'Public',
        it: 'Pubblico',
      },
      reward_type: {
        el: 'Τύπος επιβράβευσης',
        en: 'Reward Type',
        it: 'Tipo di ricompensa',
      },
      actions: {
        el: 'Ενέργειες',
        en: 'Actions',
        it: 'Azioni',
      },
      update: {
        el: 'Ενημέρωση',
        en: 'Update',
        it: 'Aggiornamento',
      },
      delete: {
        el: 'Διαγραφή',
        en: 'Delete',
        it: 'Cancellare',
      },
      showSubscriptionPlanInfo: {
        el: 'Εμφάνιση πληροφοριών πλάνου συνδρομής',
        en: 'Show Subscription Plan Info',
        it: 'Mostra informazioni piano abbonamento',
      },
      subscriptionPlanInfo: {
        el: 'Πληροφορίες πλάνου συνδρομής',
        en: 'Subscription Plan Info',
        it: 'Informazioni piano abbonamento',
      },
      modalTitle1: {
        el: 'Προσθήκη πλάνου συνδρομής',
        en: 'Add Subscription Plan',
        it: 'Aggiungi piano di abbonamento',
      },
      modalTitle2: {
        el: 'Ενημέρωση',
        en: 'Update Subscription Plan',
        it: 'Aggiornamento',
      },
      planName: {
        el: 'Όνομα Πλάνου',
        en: 'Plan Name',
        it: 'Nome del piano',
      },
      planDescription: {
        el: 'Περιγραφή Πλάνου',
        en: 'Plan Description',
        it: 'Descrizione del piano',
      },
      planType: {
        el: 'Τύπος Πλάνου',
        en: 'Subscription Plan Type',
        it: 'Tipo di piano',
      },
      planPaymentCycle: {
        el: 'Κύκλος πληρωμών',
        en: 'Subscription Plan Payment Cycle',
        it: 'Ciclo di pagamento',
      },
      planPaymentType: {
        el: 'Subscription Plan Payment Type',
        en: 'Subscription Plan Payment Type',
        it: 'Subscription Plan Payment Type',
      },
      planDuration: {
        el: 'Subscription Plan Duration',
        en: 'Subscription Plan Duration',
        it: 'Subscription Plan Duration',
      },
      planPrice: {
        el: 'Ποσό',
        en: 'Plan Price',
        it: 'Importo',
      },
      planMinPrice: {
        el: 'Ελάχιστη τιμή',
        en: 'Plan Minimum Price',
        it: 'Prezzo minimo',
      },
      rewardPoints: {
        el: 'Πόντοι Eπιβράβευσης',
        en: 'Reward Points',
        it: 'Punti di ricompensa',
      },
      rewardType: {
        el: 'Τύπος Eπιβράβευσης',
        en: 'Reward Type',
        it: 'Tipo di ricompensa',
      },
      paymentMethods: {
        el: 'Μέθοδοι Πληρωμών',
        en: 'Payment Methods',
        it: 'Metodi di pagamento',
      },
      publish: {
        el: 'Δημοσίευση',
        en: 'Publish',
        it: 'Pubblico',
      },
      interval: {
        el: 'Περίοδος',
        en: 'Interval',
        it: 'Intervallo',
      },
      intervalCount: {
        el: 'Αριθμός περιόδων',
        en: 'Interval Count',
        it: 'Numero intervalli',
      },
      paginationText: {
        el: 'από',
        en: 'of',
        it: 'di',
      },
      includeVat: {
        el: 'με ΦΠΑ',
        en: 'after VAT',
        it: "dopo l'IVA",
      },
      credits: {
        el: 'Credits',
        en: 'Credits',
        it: 'Crediti',
      },
      thresholdCap: {
        el: 'Όριο (threshold)',
        en: 'Threshold',
        it: 'Soglia',
      },
      topUpAmount: {
        el: 'Ποσό top-up',
        en: 'Top-up amount',
        it: 'Importo top-up',
      },
      creditAmountCap: {
        el: 'Top-up ορίου (CAP)',
        en: 'Threshold Top-up amount (CAP)',
        it: 'Soglia importo top-up (CAP)',
      },
      permissions: {
        el: 'Δικαιώματα',
        en: 'Permissions',
        it: 'Permessi',
      },
      attributes: {
        el: 'Ιδιότητες',
        en: 'Attributes',
        it: 'Attributi',
      },
      cost: {
        el: 'Κόστος',
        en: 'Cost',
        it: 'Costo',
      },
      free_stores: {
        el: 'Δωρεάν καταστήματα',
        en: 'Free Stores',
        it: 'Negozi gratuiti',
      },
      monthly_fee: {
        el: 'Μηνιαίο τέλος',
        en: 'Monthly Fee',
        it: 'Canone mensile',
      },
      transactional_fee: {
        el: 'Τέλος συναλλαγής',
        en: 'Transactional Fee',
        it: 'Commissione transazione',
      },
      promotional_fee: {
        el: 'Προωθητικό τέλος',
        en: 'Promotional Fee',
        it: 'Canone promozionale',
      },
      include_franchised: {
        el: 'Η τιμολόγηση να συμπεριλαμβάνει και τα franchise καταστήματα',
        en: 'Include franchise stores in invoicing',
        it: 'Includi i negozi in franchising nella fatturazione',
      },
    },
  }),
};
